import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as DE from '@nll/datum/lib/DatumEither';
import * as A from 'fp-ts/Array';
import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import { useEffect, useState } from 'react';
export function useMutationMapper(mutation, isBusinessError, _ref) {
  var _ref2 = _slicedToArray(_ref, 4),
      loading = _ref2[0],
      success = _ref2[1],
      error = _ref2[2],
      initial = _ref2[3];

  var _useState = useState(initial),
      value = _useState[0],
      setValue = _useState[1];

  useEffect(function () {
    if (DE.isPending(mutation) || DE.isRefresh(mutation)) return setValue(loading);

    if (DE.isSuccess(mutation)) {
      return pipe(isBusinessError(mutation.value.right), E.match(function () {
        return setValue(error);
      }, function () {
        return setValue(success);
      }));
    }

    if (DE.isFailure(mutation)) return setValue(error);
    return setValue(initial);
  }, [mutation, isBusinessError, error, loading, success, initial]);
  return value;
}
export var combineMutationStatuses = function combineMutationStatuses(mutationValues) {
  if (mutationValues.includes('saving')) return 'saving';
  if (mutationValues.includes('error')) return 'error';
  if (A.every(function (val) {
    return val === 'success';
  })(mutationValues)) return 'success';
  return mutationValues[0];
};